import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear } from "date-fns";
import range from "lodash/range";
import { dateFormat } from "../../Helper/common";
import { dateFormat2 } from "../../Helper/common";

import "./calender-icon.css";

function ABMonthYear(props) {
  const {
    name,
    id,
    fieldId,
    paramStartDate,
    intialStatus,
    placeholder,
    placeholderStyle,
    errId,
    divClass,
    isRequired,
    minimumDate,
    maxDate,
    checkDetailsIndex,
    fieldName,
    isDisabled,
  } = props;

  //alert(maxDate)

  //const [startDate, setStartDate] = useState(paramStartDate);
  const [selectedDate, setSelectedDate] = useState("");
  const years = range(1970, getYear(new Date()) + 10, 1);

  const [formData, setFormData] = useState({
    [window.name]: null,
  });

  useEffect(() => {
    if (paramStartDate !== "") {
      setSelectedDate(new Date(dateFormat2("MM/YYYY", paramStartDate)));
      // alert(selectedDate)
    }
    if(paramStartDate == ''){
      setSelectedDate('');
    }
  }, [paramStartDate]);
  //

  const [minimumDateAssigned, setMinimumDateAssigned] = useState("");

  useEffect(() => {
    if (minimumDate !== "" && minimumDate !== undefined) {
      // var dt = new Date(dateFormat2("MM/YYYY", minimumDate));
      // dt.setMonth( dt.getMonth() + 1 );
      // setMinimumDateAssigned(dt);
      // let newDate;
      if(fieldName == "batch_start_year"){
        // let dtArr = minimumDate.split("-");
        // newDate = new Date(dateFormat2("MM/YYYY", `${dtArr[1]}/${dtArr[2]}`));
        let dateParts = minimumDate.split("-");
        let reformattedDate = `${dateParts[1]}/${dateParts[2]}`;
      
        let newDate = new Date(dateFormat2("MM/YYYY", reformattedDate));
      
        var month = newDate.getMonth(); // February (Month starts from 0)
        var d = new Date(newDate.getFullYear(), month + 1, 1); // Next month
        setMinimumDateAssigned(d);

      }else{
        let newDate = new Date(dateFormat2("MM/YYYY", minimumDate));
      


      // alert(newDate)

      // let n1 = newDate.getMonth() + 1 ;
      // let date = new Date()
      // date.setMonth(n1);

      // const date = new Date()
      // date.setMonth(newDate.getMonth())

      var month = newDate.getMonth(); // January

      var d = new Date(newDate.getFullYear(), month + 1, 1);
      //alert(d)
      console.log(d.toString()); // last day in January

      //  alert(d.toString());

      // newDate.setDate(newDate.getMonth() + 3);
      setMinimumDateAssigned(d);
      //  alert(date);
      }
    }
  }, [minimumDate]);

  const [maxDateAssigned, setMaxAssigned] = useState("");

  useEffect(() => {
    if (maxDate !== "" && maxDate !== undefined) {
      // var dt = new Date(dateFormat2("MM/YYYY", minimumDate));
      // dt.setMonth( dt.getMonth() + 1 );
      // setMinimumDateAssigned(dt);
      let newDate = new Date(dateFormat2("MM/YYYY", maxDate));

      // let n1 = newDate.getMonth() + 1 ;
      // let date = new Date()
      // date.setMonth(n1);

      const date = new Date();
      date.setMonth(newDate.getMonth());

      var month = newDate.getMonth(); // January
      var d = new Date(newDate.getFullYear(), month, 0);
      console.log(d.toString()); // last day in January

      // newDate.setDate(newDate.getMonth() + 3);
      setMaxAssigned(d);
      //  alert(date);
    } else {
      let today = new Date();
      setMaxAssigned(today);
      //setMaxAssigned(d);
    }
  }, [maxDate]);

  //console.log(minimumDateAssigned)

  // if(paramStartDate !== null){
  // new Date(dateFormat2("MM/YYYY", paramStartDate));
  // }

  const handleThirdPartyFloatingLabel = (e) => {
    let parent = e.target.parentElement;
    while (!parent.classList.contains("floating-label"))
      parent = parent.parentElement;

    if (parent.children[1].classList.contains("focused")) {
      //console.log(selectedDate);
      if (selectedDate !== null) {
        return false;
      } else {
        parent.children[1].classList.remove("focused");
      }
    } else {
      parent.children[1].classList.add("focused");
    }
  };

  const dateSelectHandler = (date) => {
    setSelectedDate(date);
    //setStartDate(date);
    // setSelectedDate(date);

    let formatedDate = dateFormat("MM/YYYY", date);

    //alert(formatedDate);

    // props.dateSelect([{ "name": name, "value": date, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId }]);
    props.dateSelect([
      {
        name: name,
        value: formatedDate,
        fieldId: fieldId,
        isRequired: isRequired,
        err_id: errId,
        checkdetailsindex: checkDetailsIndex,
        fieldname: fieldName,
      },
    ]);

    // props.dateSelect(date);
  };

  // useEffect(() => {

  // if(paramStartDate != undefined){

  //   console.log(paramStartDate);

  // }

  // new Date(
  //   dateFormat2(
  //     "MM/YYYY",
  //     value.fields.batch_start_year.field_value
  //   )
  // )

  //   if(paramStartDate instanceof Date){
  //   setSelectedDate(paramStartDate);
  //   }
  // }, []);

  // selected={paramStartDate !== undefined
  //   ? new Date(dateFormat2("MM/YYYY", paramStartDate))
  //   : null}

  let elementClass = 'col-sm-4 col-md-12 col-xl-4';
  if(divClass){
    elementClass = divClass;
  }

  return (
    <>
      <div className={elementClass}>
        <div className="form-group">
          {/* {paramStartDate !== null ? dateFormat2("MM/YYYY", paramStartDate) : null } */}

          <div className="floating-label has-left-icon react-date-picker">
            <DatePicker
              className="form-control calendar-icon"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              renderCustomHeader={({ date, changeYear }) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <select
                    className="month-year year-select"
                    style={{
                      maxWidth: "fit-content",
                    }}
                    value={getYear(date)}
                    onChange={({ target: { value } }) => changeYear(value)}
                  >
                    {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              selected={selectedDate}
              //  selected={ paramStartDate !== null ? new Date(dateFormat2("MM/YYYY", paramStartDate)) : selectedDate}
              id={props.id}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              showYearDropdown
              showMonthDropdown
              dateFormatCalendar="MMMM"
              //  yearDropdownItemNumber={15}
              // scrollableYearDropdown
              dropdownMode="scroll"
              onChange={(date) => dateSelectHandler(date)}
              onFocus={handleThirdPartyFloatingLabel}
              onBlur={handleThirdPartyFloatingLabel}
              autoComplete="off"
              minDate={minimumDateAssigned}
              maxDate={maxDateAssigned}
              disabledKeyboardNavigation={false}
              fixedHeight
              disabled={isDisabled}
            />
            <label
              htmlFor={props.id}
              style={placeholderStyle}
              className={formData[window.name] || (selectedDate && "focused")}
            >
              {placeholder}
              {isRequired && <sup className="text-danger">*</sup>}
            </label>
          </div>
          <p className="err text-danger" id={errId}></p>
        </div>
      </div>
    </>
  );
}

export default ABMonthYear;
